<section class="mt-2">
    <div class="action-btn px-4">
        <button class="mr-5" nz-button nzType="default" (click)="resetForm()">Reset</button>
        <button nz-button nzType="primary" (click)="saveRow()">Save</button>
    </div>
    <div class="col-md-6 d-flex flex-column position-relative" style="padding: 30px 30px 0px 30px;">
        <label class="form-label"> Select Program <span class="text-danger">*</span>
        </label>
        <nz-select [(ngModel)]="selectedProgram" (ngModelChange)="programValChange()" nzPlaceHolder="Select Program"
            nzSize="default" style="height: 35px !important;">
            @for(program of programList;track program){
            <nz-option [nzLabel]="program" [nzValue]="program"></nz-option>
            }
        </nz-select>
        <span class="error-text" *ngIf="invalidForm && !selectedProgram">
            Program value is required.
        </span>
    </div>
    <div class="form-container position-relative mt-3">
        <span style="top:20px" *ngIf="invalidForm" class="error-text">
            Atleast one Location and Job-code value is required.
        </span>
        <div class="mt-1 mb-3 d-flex justify-content-end px-1">
            <button nz-button nzType="primary" (click)="addRow()">Add New</button>
        </div>
        <div class="row">
            <nz-collapse cdkDrag class="mb-3" style="background-color: #ffff;" nzAccordion>
                <nz-collapse-panel style="padding-bottom: 20px;" [nzDisabled]="true" #panelRef [nzActive]="true"
                    [nzShowArrow]="false">
                    <div class="row d-flex align-self-center align-items-center mb-2">
                        @for(list of amdArrList;let j = $index; track list.id){
                        @if(list.fieldType == 'select'){
                        <ng-container>
                            <div class="mb-4 d-flex flex-column position-relative"
                                [ngClass]="selectedProgram ==='AMD ALLOW' ? 'col-md-4' : 'col-md-5'">
                                <label class="form-label"> {{list.fieldName}}
                                </label>
                                @if(list.placeholder == 'Select Location'){

                                <nz-select [(ngModel)]="list.value" (ngModelChange)="locationValChange(list,j)"
                                    nzPlaceHolder={{list?.placeholder}} nzSize="default" nzShowSearch="true"
                                    nzAllowClear="true" style="height: 35px !important;margin-bottom: 0px;"
                                    #locationSelect="nzSelect">
                                    @for(location of locationList;track location.locationId ){
                                    <nz-option [nzLabel]="location.locationCode"
                                        [nzValue]="location.locationCode"></nz-option>
                                    }
                                </nz-select>
                                <span class="error-text"
                                    *ngIf="list.hasError"> Location Value is required.
                                </span>
                                }
                                @else {<nz-select #multiSelectRef="nzSelect" [nzMode]="'multiple'"
                                    nzPlaceHolder={{list?.placeholder}} nzSize="default" class="custom-scroll-select"
                                    style="height: 35px !important;margin-bottom: 25px;" [(ngModel)]="list.value"
                                    [nzDropdownRender]="dropDownRender" (keydown.tab)="handleTabOnJobCode($event, j)"
                                    (ngModelChange)="pushPairs($event,j)">
                                    @for(job of list.jobCodeList;track job.jobCodeId){
                                    <nz-option [nzDisabled]="job.disabled" [nzLabel]="job.jobCode"
                                        [nzValue]="job"></nz-option>
                                    }
                                </nz-select>
                                <ng-template #dropDownRender>
                                    <div class="d-flex justify-content-end p-2">
                                        <button nz-button nzType="primary" class="ok-btn"
                                            (click)="closeSelect(multiSelectRef)">
                                            Ok
                                        </button>
                                    </div>
                                </ng-template>
                             <span class="error-text mt-1"
                                    *ngIf="list.hasError"> Job Code Value is required.
                                </span>}
                            </div>
                        </ng-container>
                        }
                        @else if(list.fieldType == 'toggle' && selectedProgram ==='AMD ALLOW'){
                        <div class="col-md-3 d-flex align-items-center flex-column">
                            @if(list.fieldName){
                            <label style="height: 35px;" class="form-label">
                                {{list.fieldName}}
                            </label>
                            }
                            <nz-switch style="margin-bottom: 35px;" [(ngModel)]="list.value"></nz-switch>
                        </div>
                        }
                        @else if(list.fieldType == 'button' ) {
                        <div
                            [ngClass]="selectedProgram ==='AMD ALLOW' ? 'col-md-1 d-flex justify-content-end' : 'col-md-2 d-flex justify-content-center'">
                            <button (click)="clearRow(list)" style="height: 32px;margin-bottom: 30px;"
                                class="margin-right" nz-button nzType="default">Clear</button>
                        </div>
                        }
                        }
                    </div>
                </nz-collapse-panel>
            </nz-collapse>
        </div>
    </div>
</section>